// import red from '@material-ui/core/colors/red';
import { lightPalette, darkPalette } from "./palette";
import { lightTypography } from "./typography";
import overrides from "./overrides";
import components from "./components";
import componentsDart from "./componentsDark";

export const sideBarNavWidth = 210;
export const sideBarNavMiniWidth = 55;
export const transition = {
  transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)",
};
export const tableHeaderColor = "#F4F6F9";

// A custom theme for this app
export const lightTheme = {
  palette: lightPalette, //https://material-ui.com/customization/palette/
  typography: lightTypography,
  overrides: overrides, //https://material-ui.com/customization/components/
  components: components,
};

export const blackTheme = {
  palette: darkPalette,
  components: componentsDart,
};
